/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Cc_Mode_EnabledInputs */

const en_styles_cc_mode_enabled = /** @type {(inputs: Styles_Cc_Mode_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closed Caption Mode Enabled`)
};

const fr_styles_cc_mode_enabled = /** @type {(inputs: Styles_Cc_Mode_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode sous-titrage active`)
};

const de_styles_cc_mode_enabled = /** @type {(inputs: Styles_Cc_Mode_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitelmodus aktiviert`)
};

const it_styles_cc_mode_enabled = /** @type {(inputs: Styles_Cc_Mode_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modalità sottotitoli abilitata`)
};

const ru_styles_cc_mode_enabled = /** @type {(inputs: Styles_Cc_Mode_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Режим субтитров включен`)
};

const es_styles_cc_mode_enabled = /** @type {(inputs: Styles_Cc_Mode_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modo de subtítulos habilitado`)
};

const zh_cn2_styles_cc_mode_enabled = /** @type {(inputs: Styles_Cc_Mode_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已启用隐藏式字幕模式`)
};

const ja_styles_cc_mode_enabled = /** @type {(inputs: Styles_Cc_Mode_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クローズドキャプションモードが有効`)
};

const hi_styles_cc_mode_enabled = /** @type {(inputs: Styles_Cc_Mode_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्लोज्ड कैप्शन मोड सक्षम किया गया है`)
};

const pt_pt2_styles_cc_mode_enabled = /** @type {(inputs: Styles_Cc_Mode_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legendas ativadas`)
};

/**
* | output |
* | --- |
* | "Closed Caption Mode Enabled" |
*
* @param {Styles_Cc_Mode_EnabledInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_cc_mode_enabled = /** @type {((inputs?: Styles_Cc_Mode_EnabledInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Cc_Mode_EnabledInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_cc_mode_enabled(inputs)
	if (locale === "de") return de_styles_cc_mode_enabled(inputs)
	if (locale === "it") return it_styles_cc_mode_enabled(inputs)
	if (locale === "ru") return ru_styles_cc_mode_enabled(inputs)
	if (locale === "es") return es_styles_cc_mode_enabled(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_cc_mode_enabled(inputs)
	if (locale === "ja") return ja_styles_cc_mode_enabled(inputs)
	if (locale === "hi") return hi_styles_cc_mode_enabled(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_cc_mode_enabled(inputs)
	return en_styles_cc_mode_enabled(inputs)
});